import "bootstrap/dist/css/bootstrap.min.css";
import { createRoot } from "react-dom/client";
import ProductForm from "./routes/products/addProducts";

// import './index.css';
// import App from './App';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
// import Orders1 from './routes/orders/Orders1'
import Config from "./routes/config/Config";
import Products from "./routes/products/Products";
import Reporting from "./routes/reporting/Reporting";
// import Orders2 from './routes/orders/orders/Orders2';
import { Provider } from "react-redux";
import Cart from "./cart";
import AuthWrapper from "./components/AuthWrapper";
import store from "./redux/store";
import LoginPage from "./routes/dashboard/LoginPage";
import DefaultProducts from "./routes/DefaultProduct";
import Customers from "./routes/orders/customers/Customer";
import POSCustomer from "./routes/orders/customers/POSCustomers";
import CreateOrderForm from "./routes/orders/orders/CreateOrderForm";
import Payment from "./routes/orders/orders/Payment";
import POSOrders from "./routes/orders/orders/POSOrders";
import Payments from "./routes/orders/payments/Payments";
import Sessions from "./routes/orders/sessions/Sessions";
import Posboard from "./routes/pos/Posboard";
import SalesDetails from "./routes/reporting/SalesDetails";
import SalesReport from "./routes/reporting/SalesReport";
import Categories from "./routes/settings/categories";

let container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/pos"
          element={
            <AuthWrapper>
              <Posboard />
            </AuthWrapper>
          }
        />
        <Route
          path="/dashboard"
          element={
            <AuthWrapper>
              <Posboard />
            </AuthWrapper>
          }
        />
        {/* <Route path="/orders1" element={<Orders1 />} /> */}
        {/* <Route path="orders1/orders2" element={<Orders2 />} /> */}
        <Route
          path="createorder"
          element={
            <AuthWrapper>
              <CreateOrderForm mode="createorder" />
            </AuthWrapper>
          }
        />
        <Route
          path="poscutomerscreen"
          element={
            <AuthWrapper>
              <CreateOrderForm mode="customer-screen" />
            </AuthWrapper>
          }
        />
        <Route path="/orders1/sessions" element={<Sessions />} />
        <Route path="/pos/payments" element={<Payments />} />
        <Route path="/orders1/customers" element={<Customers />} />
        <Route
          path="/pos/products"
          element={
            <AuthWrapper>
              <Products />
            </AuthWrapper>
          }
        />
        <Route
          path="/pos/DefaultProducts/"
          element={
            <AuthWrapper>
              <DefaultProducts />
            </AuthWrapper>
          }
        />
        <Route path="/reporting" element={<Reporting />} />
        <Route path="/pos/reporting/sales" element={<SalesDetails />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/config" element={<Config />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/pos/addProduct" element={<ProductForm />} />
        <Route path="/pos/editProduct" element={<ProductForm />} />
        <Route path="/pos/Categories" element={<Categories />} />
        <Route path="/pos/orders" element={<POSOrders />} />
        <Route
          path="/reporting/orders"
          element={
            <AuthWrapper>
              <SalesReport mode="orders" />
            </AuthWrapper>
          }
        />
        <Route
          path="/reporting/sales-details"
          element={
            <AuthWrapper>
              <SalesReport mode="sales" />
            </AuthWrapper>
          }
        />
        <Route path="/pos/customers" element={<POSCustomer />} />
      </Routes>
    </BrowserRouter>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
